import case1 from "../../assets/case1.jpg";
import case2 from "../../assets/case2.jpg";
import case3 from "../../assets/case3.jpg";
import case4 from "../../assets/case4.jpg";

function Cases() {
    return ( 
        <>
            <section className="cases">
                <div className="container">
                    <h2 class="main-header">Earnings of our models</h2><br />
                    <h2 class="secondary-header">Transform your passion into profit!</h2>
                    <div className="container-row">
                        <div className="image-container">
                            <img src={case1} alt="" />
                        </div>
                        <div className="image-container">
                            <img src={case2} alt="" />
                        </div>
                        <div className="image-container">
                            <img src={case3} alt="" />
                        </div>
                        <div className="image-container">
                            <img src={case4} alt="" />
                        </div>
                    </div>
                </div>
            </section>
        </>
     );
}

export default Cases;